<template>
    <div class="checkbox-toggle d-inline mt-1">
        <input v-on:input="onInput" type="checkbox" :id="getInputKey()" :checked="value" :disabled="disabled">
        <label :for="getInputKey()"></label>
    </div>
</template>
<script>
export default {
    data() {
        return {
            randomKey: Math.floor(Math.random() * 1000000),
        }
    },

    props: ['value', 'disabled'],

    computed: {

    },

    watch: {

    },

    methods: {
        onInput(e) {
            const value = e.target.checked;

            this.$emit('input', value);
            // this.$emit('change', value);
        },

        getInputKey() {
            return `switch-${this.randomKey}`;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/CustomSwitchComponent.vue